/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * ---------------------------------------------------------------------------------------------
 */

import { makeStyles } from '@fluentui/react-components';
import React from 'react';

import { Grid } from '@tdp/common/fluentV9MigrationComponents';

import { IContentFeedCard, NewContentFeedCard } from './Card';

interface IContentFeedLayout {
  cards: IContentFeedCard[];
}
const useStyle = makeStyles({
  button: {
    color: '#1372BA',
    paddingTop: '9px',
    paddingRight: '0',
    paddingBottom: '8px',
    paddingLeft: '8px',
  },
  container: {
    justifyContent: 'space-evenly',
    flexWrap: 'nowrap',
  },
  grid: {
    maxWidth: '100%',
    gap: '20px',
    width: '100%',
    height: '100%',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    '@media (max-width: 640px)': {
      gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
      gap: '10px',
    },
    '@media (min-width: 1007px)': {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },
  list: {
    gap: '12px',
  },
});
export const ContentFeedLayout: React.FC<IContentFeedLayout> = ({ cards }) => {
  const classes = useStyle();
  return (
    <Grid className={classes.grid} data-testid="content-feed-section">
      {cards.map((card: IContentFeedCard) => (
        <NewContentFeedCard key={card.title} {...card} />
      ))}
    </Grid>
  );
};
